"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var outlet_1 = require("./outlet");
exports.OutletService = outlet_1.OutletService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/outlet/services/index.js
// module id = 380
// module chunks = 0